/**
 * Language Constants
 * Centralized language configuration for the application.
 * This is the single source of truth for all language-related data.
 */

export const LANGUAGES = [
  { label: "US English (Source)", value: "en-US" },
  { label: "Arabic", value: "sa-AR" },
  { label: "Bahasa", value: "id-ID" },
  { label: "English (Australia)", value: "en-AU" },
  { label: "French", value: "fr-FR" },
  { label: "German", value: "de-DE" },
  { label: "Hindi", value: "hi-IN" },
  { label: "Italian", value: "it-IT" },
  { label: "Portuguese (Brazil)", value: "pt-BR" },
  { label: "Spanish (LATAM)", value: "es-LA" },
  { label: "Spanish (Spain)", value: "es-ES" },
  { label: "Tagalog", value: "tl-PH" },
  { label: "Thai", value: "th-TH" },
  { label: "Vietnamese", value: "vi-VN" },
];
